module.exports = __webpack_public_path__ + "img/logo.080cbd79.svg";